import type { QuestionnaireProgress } from "./types";

/** A goal flattened out of the progress tree, carrying its issue/thematic context. */
export interface FlatGoal {
  goalId: string;
  goalName: string;
  total: number;
  answered: number;
  issueId: string;
  issueName: string;
  issueIcon: string;
  thematicId: string;
  thematicName: string;
  cssClass: string;
}

/** Per-thematic totals, for the segmented overall-progress strip. */
export interface ThematicTotal {
  id: string;
  name: string;
  cssClass: string;
  answered: number;
  total: number;
}

/** Flatten the progress tree to an ordered goal list (tree order preserved). */
export function flattenGoals(progress: QuestionnaireProgress): FlatGoal[] {
  const out: FlatGoal[] = [];
  for (const thematic of progress.thematics) {
    for (const issue of thematic.issues) {
      for (const goal of issue.goals) {
        out.push({
          goalId: goal.id,
          goalName: goal.name,
          total: goal.total_actions,
          answered: goal.answered_actions,
          issueId: issue.id,
          issueName: issue.name,
          issueIcon: issue.icon,
          thematicId: thematic.id,
          thematicName: thematic.name,
          cssClass: thematic.css_class,
        });
      }
    }
  }
  return out;
}

export function thematicTotals(progress: QuestionnaireProgress): ThematicTotal[] {
  return progress.thematics.map((thematic) => ({
    id: thematic.id,
    name: thematic.name,
    cssClass: thematic.css_class,
    answered: thematic.answered_actions,
    total: thematic.total_actions,
  }));
}

/** True when the goal has actions and all of them are answered. */
export function isGoalComplete(goal: { total: number; answered: number }): boolean {
  return goal.total > 0 && goal.answered >= goal.total;
}
